<div class="st-select-story-template-container">
    <div class="st-select-story-template-header">
        <st-text-area-overlay
            class="st-select-story-template-header__title"
            required
            minHeight="2rem"
            panelClass="st-select-story-template-header__title"
            [value]="data.title"
            [placeholder]="languageSettings.PSTWebSlugPlaceholder"
            (changed)="updateTitle($event)" />
    </div>
    <div class="st-select-story-template-templates">
        <span class="st-select-story-template-templates__label">Templates</span>
        <mat-radio-group
            class="st-select-story-template-templates__radio-group"
            [value]="selectedStoryTemplate"
            (change)="selectStoryTemplate($event)">
            @for (item of storyTemplates(); track item.Guid) {
                <mat-radio-button [value]="item.Guid">{{ item.Title }}</mat-radio-button>
            }
        </mat-radio-group>
    </div>
    <mat-divider />
    <div class="st-select-story-template-buttons-container">
        <button
            mat-button
            (click)="cancel()">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>
        <button
            mat-button
            color="primary"
            [disabled]="!selectedStoryTemplate || !data.title"
            (click)="save()">
            @if (!loading) {
                {{ languageSettings.PSTWebSaveButtonLabel }}
            } @else {
                <st-loader
                    class="st-select-story-template-footer-buttons--spinner"
                    [diameter]="30"
                    [strokeWidth]="5" />
            }
        </button>
    </div>
</div>
